<template>
  <div>
    <v-app-bar dense dark app class="custom-top-bar" elevate-on-scroll>
      <v-app-bar-nav-icon @click="navigation()"></v-app-bar-nav-icon>

      <!-- Badge / Card de Cliente y RUC (Diseño Horizontal UI/UX) -->
      <div class="topbar-client-wrapper d-flex align-center ml-1 ml-sm-2">
        <div class="topbar-client-card d-flex align-center">
          <!-- 1. Avatar / Logo / Icono -->
          <div class="topbar-client-avatar flex-shrink-0">
            <v-img
              v-if="Cliente && (Cliente.imagen || Cliente.logo)"
              :src="Cliente.imagen || Cliente.logo"
              alt="Logo"
              class="topbar-client-img"
            ></v-img>
            <v-icon v-else small color="#38bdf8">mdi-domain</v-icon>
            <span
              class="topbar-client-status-dot"
              title="Cliente activo"
            ></span>
          </div>

          <!-- 2. RUC: visible solo en sm+ -->
          <v-tooltip
            bottom
            content-class="topbar-client-tooltip"
            open-delay="200"
            v-if="clienteRuc"
          >
            <template v-slot:activator="{ on, attrs }">
              <div
                class="topbar-ruc-pill flex-shrink-0 d-none d-sm-flex"
                :class="{ copied: rucCopied }"
                v-bind="attrs"
                v-on="on"
                @click.stop="copiarRuc(clienteRuc)"
                role="button"
                tabindex="0"
                title="Clic para copiar RUC"
              >
                <span class="topbar-ruc-tag">RUC</span>
                <span class="topbar-ruc-num">{{ clienteRuc }}</span>
                <v-icon
                  x-small
                  class="topbar-ruc-copy-icon ml-1"
                  :color="rucCopied ? '#34d399' : '#94a3b8'"
                >
                  {{ rucCopied ? "mdi-check" : "mdi-content-copy" }}
                </v-icon>
              </div>
            </template>
            <span>{{
              rucCopied
                ? "¡RUC copiado al portapapeles!"
                : "Clic para copiar RUC: " + clienteRuc
            }}</span>
          </v-tooltip>

          <!-- 3. Separador sutil: solo sm+ -->
          <div
            class="topbar-client-divider flex-shrink-0 d-none d-sm-block"
          ></div>

          <!-- 4. Razón Social: nombre completo en sm+, abreviado en xs -->
          <v-tooltip
            bottom
            content-class="topbar-client-tooltip"
            open-delay="300"
          >
            <template v-slot:activator="{ on, attrs }">
              <div
                class="topbar-client-name-wrap d-flex align-center overflow-hidden"
                v-bind="attrs"
                v-on="on"
              >
                <!-- Nombre completo: sm y superior -->
                <span
                  class="topbar-client-name text-truncate d-none d-sm-inline"
                >
                  {{ clienteRazonSocial }}
                </span>
                <!-- Nombre abreviado: solo xs -->
                <span
                  class="topbar-client-name text-truncate d-inline d-sm-none topbar-name-mobile"
                >
                  {{ clienteNombreCorto }}
                </span>
                <span
                  v-if="clienteSlug"
                  class="topbar-client-slug ml-1 d-none d-md-inline-block"
                >
                  {{ clienteSlug }}
                </span>
              </div>
            </template>
            <div class="topbar-tooltip-content pa-1">
              <div class="d-flex align-center mb-1">
                <v-icon x-small color="#38bdf8" class="mr-1"
                  >mdi-office-building</v-icon
                >
                <strong class="white--text">{{ clienteRazonSocial }}</strong>
              </div>
              <div
                v-if="clienteRuc"
                class="text-caption grey--text text--lighten-1"
              >
                <v-icon x-small color="#94a3b8" class="mr-1"
                  >mdi-card-account-details-outline</v-icon
                >
                <span
                  >RUC:
                  <strong class="white--text">{{ clienteRuc }}</strong></span
                >
              </div>
              <div
                v-if="Cliente && Cliente.direccion"
                class="text-caption grey--text text--lighten-2 mt-1"
              >
                <v-icon x-small color="#94a3b8" class="mr-1"
                  >mdi-map-marker-outline</v-icon
                >
                <span>{{ Cliente.direccion }}</span>
              </div>
            </div>
          </v-tooltip>
        </div>
      </div>

      <v-spacer></v-spacer>

      <!-- ========== BOTONES ACCIÓN: solo sm+ ========== -->
      <div class="d-none d-sm-flex align-center">
        <!-- Reportes Administrativos -->
        <v-menu
          offset-y
          origin="top right"
          transition="scale-transition"
          content-class="report-dropdown-menu"
          max-width="390"
          min-width="340"
          v-if="roleeee == 1 || roleeee == 2"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on: tooltipOn }">
                <v-badge
                  :content="
                    adminreportescount.length != 0
                      ? adminreportescount.length
                      : '0'
                  "
                  :value="adminreportescount.length > 0"
                  color="amber darken-2"
                  overlap
                  class="custom-badge"
                >
                  <v-btn
                    icon
                    v-bind="attrs"
                    v-on="{ ...on, ...tooltipOn }"
                    class="bar-action-btn"
                    aria-label="Reportes por Aprobar"
                  >
                    <v-icon
                      :color="
                        adminreportescount.length > 0 ? 'amber lighten-2' : ''
                      "
                    >
                      mdi-file-document-outline
                    </v-icon>
                  </v-btn>
                </v-badge>
              </template>
              <span>Reportes por Aprobar</span>
            </v-tooltip>
          </template>

          <div class="report-menu-card">
            <!-- Encabezado del Menú -->
            <div
              class="report-menu-header d-flex align-center justify-space-between px-4 py-3"
            >
              <div class="d-flex align-center">
                <div class="report-header-avatar mr-3">
                  <v-icon small color="amber darken-3"
                    >mdi-clipboard-text-clock-outline</v-icon
                  >
                </div>
                <div>
                  <div class="report-menu-title">Reportes por Aprobar</div>
                  <div class="report-menu-subtitle">
                    Pendientes de supervisión
                  </div>
                </div>
              </div>
              <span
                class="report-count-pill"
                v-if="adminreportescount.length > 0"
              >
                {{ adminreportescount.length }}
                {{
                  adminreportescount.length === 1 ? "pendiente" : "pendientes"
                }}
              </span>
            </div>

            <v-divider></v-divider>

            <!-- Listado Desplazable -->
            <div class="report-scroll-container">
              <template v-if="adminreportescount.length > 0">
                <div
                  v-for="(item, i) in adminreportescount"
                  :key="'rep-' + i"
                  class="report-card-item"
                  :class="
                    'report-status-border-' + (item.estado || '').toLowerCase()
                  "
                  @click="redireccionar_reportes(item)"
                >
                  <!-- Fila 1: Cliente y Badge de Estado -->
                  <div class="d-flex align-center justify-space-between mb-1">
                    <div
                      class="report-client-name text-truncate mr-2"
                      :title="item.razon_social || item.reporte"
                    >
                      <v-icon x-small class="mr-1 client-icon"
                        >mdi-domain</v-icon
                      >
                      <span class="text-truncate">{{
                        item.razon_social ||
                        item.reporte ||
                        "Cliente no especificado"
                      }}</span>
                    </div>
                    <span
                      class="report-badge-status"
                      :class="getEstadoColorClass(item.estado)"
                    >
                      <v-icon
                        x-small
                        class="mr-1"
                        :color="getEstadoIconColor(item.estado)"
                      >
                        {{ getEstadoIcon(item.estado) }}
                      </v-icon>
                      {{ item.estado }}
                    </span>
                  </div>

                  <!-- Fila 2: Período y Técnico (si existen) -->
                  <div
                    class="report-meta-row d-flex align-center flex-wrap mb-1"
                  >
                    <span
                      class="report-meta-item mr-3"
                      v-if="item.consulta_mes && item.consulta_anio"
                    >
                      <v-icon x-small class="mr-1 meta-icon"
                        >mdi-calendar-range-outline</v-icon
                      >
                      <span
                        >Período:
                        <strong
                          >{{ item.consulta_mes }}/{{
                            item.consulta_anio
                          }}</strong
                        ></span
                      >
                    </span>
                    <span class="report-meta-item" v-if="item.name">
                      <v-icon x-small class="mr-1 meta-icon"
                        >mdi-account-outline</v-icon
                      >
                      <span class="text-truncate" style="max-width: 140px">{{
                        item.name
                      }}</span>
                    </span>
                  </div>

                  <!-- Fila 3: Fecha de Envío y Acción Revisar -->
                  <div
                    class="d-flex align-center justify-space-between pt-1 report-card-footer"
                  >
                    <span class="report-date-text">
                      <v-icon x-small class="mr-1 date-icon"
                        >mdi-clock-outline</v-icon
                      >
                      {{ formatearFecha(item.fecha || item.created_at) }}
                    </span>
                    <span class="report-action-link d-flex align-center">
                      <span>Revisar</span>
                      <v-icon x-small class="ml-1 action-arrow"
                        >mdi-chevron-right</v-icon
                      >
                    </span>
                  </div>
                </div>
              </template>

              <!-- Estado Vacío -->
              <div v-else class="report-empty-container text-center py-6 px-4">
                <div class="report-empty-icon-circle mb-2">
                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                </div>
                <div class="report-empty-title">Sin reportes pendientes</div>
                <div class="report-empty-desc">
                  Todos los reportes han sido revisados y aprobados.
                </div>
              </div>
            </div>

            <!-- Footer con Botón de Actualizar -->
            <div class="report-footer-actions pa-2">
              <v-btn
                text
                block
                small
                color="amber darken-3"
                class="report-btn-view-all font-weight-bold text-none"
                @click="recargarReportes()"
              >
                <v-icon left small>mdi-refresh</v-icon>
                Actualizar reportes
              </v-btn>
            </div>
          </div>
        </v-menu>
        <!-- Notificación: Neumáticos Próximos a Reencauchar -->
        <v-menu
          offset-y
          origin="top right"
          transition="scale-transition"
          content-class="prox-reencauche-dropdown-menu"
          max-width="390"
          min-width="340"
          v-if="hasClientId"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on: tooltipOn }">
                <v-badge
                  :content="
                    itemsneuproxreencauchar.length != 0
                      ? itemsneuproxreencauchar.length
                      : '0'
                  "
                  :value="itemsneuproxreencauchar.length > 0"
                  color="orange darken-2"
                  overlap
                  class="custom-badge"
                >
                  <v-btn
                    icon
                    v-bind="attrs"
                    v-on="{ ...on, ...tooltipOn }"
                    class="bar-action-btn"
                    aria-label="Neumáticos Próximos a Reencauchar"
                  >
                    <v-icon
                      :color="
                        itemsneuproxreencauchar.length > 0
                          ? 'orange lighten-2'
                          : ''
                      "
                    >
                      mdi-tire
                    </v-icon>
                  </v-btn>
                </v-badge>
              </template>
              <span>Próximos a Reencauchar</span>
            </v-tooltip>
          </template>

          <div class="neu-menu-card">
            <!-- Header -->
            <div
              class="neu-menu-header d-flex align-center justify-space-between px-4 py-3"
            >
              <div class="d-flex align-center">
                <div class="neu-header-avatar avatar-orange mr-3">
                  <v-icon small color="orange darken-3">mdi-tire</v-icon>
                </div>
                <div>
                  <div class="neu-menu-title">Próximos a Reencauchar</div>
                  <div class="neu-menu-subtitle">
                    Desgaste cercano al límite de servicio
                  </div>
                </div>
              </div>
              <span
                class="neu-count-pill pill-orange"
                v-if="itemsneuproxreencauchar.length > 0"
              >
                {{ itemsneuproxreencauchar.length }} en alerta
              </span>
            </div>

            <v-divider></v-divider>

            <!-- Listado Desplazable -->
            <div class="neu-scroll-container">
              <template v-if="itemsneuproxreencauchar.length > 0">
                <div
                  v-for="(item, i) in itemsneuproxreencauchar"
                  :key="'prox-' + i"
                  class="neu-card-item card-border-orange"
                  @click="
                    item.vehiculo_id ? gomantvehi(item.vehiculo_id) : null
                  "
                  :style="
                    item.vehiculo_id ? 'cursor: pointer;' : 'cursor: default;'
                  "
                >
                  <!-- Fila 1: Serie y Marca -->
                  <div class="d-flex align-center justify-space-between mb-1">
                    <div class="neu-serial-title text-truncate mr-2">
                      <v-icon x-small class="mr-1" color="orange darken-2"
                        >mdi-barcode</v-icon
                      >
                      <span class="font-weight-bold"
                        >Serie: {{ item.num_serie }}</span
                      >
                    </div>
                    <span class="neu-brand-badge" v-if="item.marca">
                      {{ item.marca }}
                    </span>
                  </div>

                  <!-- Fila 2: Vehículo / Placa -->
                  <div
                    class="neu-meta-text d-flex align-center mb-1"
                    v-if="item.vehiculo_placa || item.vehiculo_id"
                  >
                    <v-icon x-small class="mr-1 meta-icon"
                      >mdi-truck-outline</v-icon
                    >
                    <span
                      >Vehículo:
                      <strong>{{
                        item.vehiculo_placa || "ID: " + item.vehiculo_id
                      }}</strong></span
                    >
                  </div>

                  <!-- Fila 3: Porcentaje de Desgaste con barra -->
                  <div class="neu-progress-section my-2">
                    <div class="d-flex justify-space-between align-center mb-1">
                      <span class="caption text-muted">Nivel de desgaste</span>
                      <span class="font-weight-bold neu-percentage-orange">
                        {{ item.porcentaje_desgaste }}%
                      </span>
                    </div>
                    <v-progress-linear
                      :value="item.porcentaje_desgaste"
                      height="6"
                      rounded
                      color="orange darken-1"
                      class="neu-progress-bar"
                    ></v-progress-linear>
                  </div>

                  <!-- Fila 4: Remanente actual y Acción -->
                  <div
                    class="d-flex align-center justify-space-between pt-1 neu-card-footer"
                  >
                    <span
                      class="neu-rem-text"
                      v-if="item.remanente_actual !== undefined"
                    >
                      <v-icon x-small class="mr-1 meta-icon">mdi-ruler</v-icon>
                      Remanente: <strong>{{ item.remanente_actual }} mm</strong>
                    </span>
                    <span
                      class="neu-action-link link-orange d-flex align-center"
                      v-if="item.vehiculo_id"
                    >
                      <span>Ver Vehículo</span>
                      <v-icon x-small class="ml-1 action-arrow"
                        >mdi-chevron-right</v-icon
                      >
                    </span>
                  </div>
                </div>
              </template>

              <!-- Estado Vacío -->
              <div v-else class="neu-empty-container text-center py-6 px-4">
                <div class="neu-empty-icon-circle mb-2">
                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                </div>
                <div class="neu-empty-title">Sin neumáticos en alerta</div>
                <div class="neu-empty-desc">
                  Todos los neumáticos se encuentran en rangos óptimos de
                  desgaste.
                </div>
              </div>
            </div>

            <!-- Footer con Botón de Actualizar -->
            <div class="neu-footer-actions pa-2">
              <v-btn
                text
                block
                small
                color="orange darken-3"
                class="neu-btn-footer font-weight-bold text-none"
                @click="recargarProxReencauchar()"
              >
                <v-icon left small>mdi-refresh</v-icon>
                Actualizar alertas
              </v-btn>
            </div>
          </div>
        </v-menu>

        <!-- Notificación: Neumáticos a Reencauchar (Límite Crítico) -->
        <v-menu
          offset-y
          origin="top right"
          transition="scale-transition"
          content-class="reencauche-dropdown-menu"
          max-width="390"
          min-width="340"
          v-if="hasClientId"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on: tooltipOn }">
                <v-badge
                  :content="
                    itemsneureencauchar.length != 0
                      ? itemsneureencauchar.length
                      : '0'
                  "
                  :value="itemsneureencauchar.length > 0"
                  color="red darken-2"
                  overlap
                  class="custom-badge"
                >
                  <v-btn
                    icon
                    v-bind="attrs"
                    v-on="{ ...on, ...tooltipOn }"
                    class="bar-action-btn"
                    aria-label="Neumáticos a Reencauchar"
                  >
                    <v-icon
                      :color="
                        itemsneureencauchar.length > 0 ? 'red lighten-2' : ''
                      "
                    >
                      mdi-car-tire-alert
                    </v-icon>
                  </v-btn>
                </v-badge>
              </template>
              <span>Neumáticos a Reencauchar</span>
            </v-tooltip>
          </template>

          <div class="neu-menu-card">
            <!-- Header -->
            <div
              class="neu-menu-header d-flex align-center justify-space-between px-4 py-3"
            >
              <div class="d-flex align-center">
                <div class="neu-header-avatar avatar-red mr-3">
                  <v-icon small color="red darken-3">mdi-car-tire-alert</v-icon>
                </div>
                <div>
                  <div class="neu-menu-title">Neumáticos a Reencauchar</div>
                  <div class="neu-menu-subtitle">
                    Han alcanzado el remanente mínimo permitido
                  </div>
                </div>
              </div>
              <span
                class="neu-count-pill pill-red"
                v-if="itemsneureencauchar.length > 0"
              >
                {{ itemsneureencauchar.length }} críticos
              </span>
            </div>

            <v-divider></v-divider>

            <!-- Listado Desplazable -->
            <div class="neu-scroll-container">
              <template v-if="itemsneureencauchar.length > 0">
                <div
                  v-for="(item, i) in itemsneureencauchar"
                  :key="'reenc-' + i"
                  class="neu-card-item card-border-red"
                  @click="gomantvehi(item.vehiculo_id)"
                >
                  <!-- Fila 1: Serie y Badge de Acción Inmediata -->
                  <div class="d-flex align-center justify-space-between mb-1">
                    <div class="neu-serial-title text-truncate mr-2">
                      <v-icon x-small class="mr-1" color="red darken-2"
                        >mdi-barcode</v-icon
                      >
                      <span class="font-weight-bold"
                        >Serie: {{ item.num_serie }}</span
                      >
                    </div>
                    <span class="neu-status-pill-red">
                      <v-icon x-small class="mr-1" color="red darken-2"
                        >mdi-alert-circle-outline</v-icon
                      >
                      Retirar
                    </span>
                  </div>

                  <!-- Fila 2: Marca y Vehículo / Placa -->
                  <div
                    class="d-flex align-center justify-space-between neu-meta-text mb-2"
                  >
                    <span v-if="item.marca">
                      Marca: <strong>{{ item.marca }}</strong>
                    </span>
                    <span v-if="item.vehiculo_placa || item.vehiculo_id">
                      <v-icon x-small class="mr-1 meta-icon"
                        >mdi-truck-outline</v-icon
                      >
                      Placa:
                      <strong>{{
                        item.vehiculo_placa || item.vehiculo_id
                      }}</strong>
                    </span>
                  </div>

                  <!-- Fila 3: Comparativa Remanentes -->
                  <div class="neu-rem-grid pa-2 rounded-lg mb-2">
                    <div class="d-flex justify-space-between align-center">
                      <span class="caption text-muted">Remanente Límite:</span>
                      <span class="font-weight-medium">
                        {{
                          item.remanente_limite ||
                          item.rem_apli_reencauche ||
                          "-"
                        }}
                        mm
                      </span>
                    </div>
                    <div class="d-flex justify-space-between align-center mt-1">
                      <span
                        class="caption font-weight-bold red--text text--darken-2"
                        >Remanente Actual:</span
                      >
                      <span class="font-weight-bold red--text text--darken-2">
                        {{ item.remanente_actual }} mm
                      </span>
                    </div>
                  </div>

                  <!-- Fila 4: Acción Ir al Vehículo -->
                  <div
                    class="d-flex align-center justify-end pt-1 neu-card-footer"
                  >
                    <span class="neu-action-link link-red d-flex align-center">
                      <span>Gestionar en Vehículo</span>
                      <v-icon x-small class="ml-1 action-arrow"
                        >mdi-chevron-right</v-icon
                      >
                    </span>
                  </div>
                </div>
              </template>

              <!-- Estado Vacío -->
              <div v-else class="neu-empty-container text-center py-6 px-4">
                <div class="neu-empty-icon-circle mb-2">
                  <v-icon color="success">mdi-check-circle-outline</v-icon>
                </div>
                <div class="neu-empty-title">Sin neumáticos críticos</div>
                <div class="neu-empty-desc">
                  Ningún neumático requiere retiro o reencauche inmediato.
                </div>
              </div>
            </div>

            <!-- Footer con Botón de Actualizar -->
            <div class="neu-footer-actions pa-2">
              <v-btn
                text
                block
                small
                color="red darken-3"
                class="neu-btn-footer font-weight-bold text-none"
                @click="recargarReencauchar()"
              >
                <v-icon left small>mdi-refresh</v-icon>
                Actualizar reencauches
              </v-btn>
            </div>
          </div>
        </v-menu>

        <v-tooltip bottom v-if="mostraricononotificaciones == true">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              :href="supportUrl"
              target="_blank"
              icon
              v-bind="attrs"
              v-on="on"
              class="bar-action-btn"
              aria-label="Reportar Incidencia"
            >
              <v-icon>mdi-headset</v-icon>
            </v-btn>
          </template>
          <span>Reportar Incidencia a Soporte</span>
        </v-tooltip>

        <!-- Botón de Notificaciones -->
        <v-menu
          offset-y
          origin="top right"
          transition="scale-transition"
          content-class="incident-dropdown-menu"
          max-width="390"
          min-width="340"
          v-if="mostraricononotificaciones == false"
        >
          <!-- <template v-slot:activator="{ on, attrs }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on: tooltipOn }">
              <v-badge
                :content="
                  listaIncidentes.length != 0 ? listaIncidentes.length : '0'
                "
                :value="listaIncidentes.length > 0"
                color="teal darken-1"
                overlap
                class="custom-badge"
              >
                <v-btn
                  icon
                  v-bind="attrs"
                  v-on="{ ...on, ...tooltipOn }"
                  class="bar-action-btn"
                  aria-label="Incidencias de Soporte"
                >
                  <v-icon
                    :color="listaIncidentes.length > 0 ? 'teal lighten-3' : ''"
                  >
                    mdi-headset
                  </v-icon>
                </v-btn>
              </v-badge>
            </template>
            <span>Incidencias de Soporte</span>
          </v-tooltip>
        </template> -->

          <div class="incident-menu-card">
            <!-- Encabezado del Menú -->
            <div
              class="incident-menu-header d-flex align-center justify-space-between px-4 py-3"
            >
              <div class="d-flex align-center">
                <div class="incident-header-avatar mr-3">
                  <v-icon small color="teal darken-2">mdi-headset</v-icon>
                </div>
                <div>
                  <div class="incident-menu-title">Incidencias de Soporte</div>
                  <div class="incident-menu-subtitle">
                    Tickets pendientes de atención
                  </div>
                </div>
              </div>
              <span
                class="incident-count-pill"
                v-if="listaIncidentes.length > 0"
              >
                {{ listaIncidentes.length }}
                {{ listaIncidentes.length === 1 ? "pendiente" : "pendientes" }}
              </span>
            </div>

            <v-divider></v-divider>

            <!-- Listado Desplazable -->
            <div class="incident-scroll-container">
              <template v-if="listaIncidentes.length > 0">
                <div
                  v-for="(item, index) in listaIncidentes"
                  :key="'inc-' + index"
                  class="incident-card-item"
                  @click="mostrarmodal(item)"
                >
                  <!-- Fila 1: Título / ID y Badge Estado -->
                  <div class="d-flex align-center justify-space-between mb-1">
                    <div class="incident-ticket-title text-truncate mr-2">
                      <span
                        >Ticket #{{
                          item.datos && item.datos.id
                            ? item.datos.id
                            : index + 1
                        }}</span
                      >
                    </div>
                    <span class="incident-badge-status status-badge-pending">
                      <v-icon x-small class="mr-1" color="teal darken-2"
                        >mdi-clock-outline</v-icon
                      >
                      Pendiente
                    </span>
                  </div>

                  <!-- Fila 2: Empresa y Usuario -->
                  <div
                    class="incident-client-name text-truncate mb-1"
                    v-if="item.datos && item.datos.razon_social"
                    :title="item.datos.razon_social"
                  >
                    <v-icon x-small class="mr-1 client-icon">mdi-domain</v-icon>
                    <span class="text-truncate">{{
                      item.datos.razon_social
                    }}</span>
                  </div>

                  <div
                    class="incident-user-name text-truncate mb-1"
                    v-if="
                      item.datos &&
                      item.datos.usuario &&
                      item.datos.usuario.name
                    "
                  >
                    <v-icon x-small class="mr-1 user-icon"
                      >mdi-account-outline</v-icon
                    >
                    <span class="text-truncate">{{
                      item.datos.usuario.name
                    }}</span>
                  </div>

                  <!-- Fila 3: Descripción de la Incidencia -->
                  <div
                    class="incident-desc-text text-truncate-2"
                    v-if="item.datos && item.datos.descripcion"
                    :title="item.datos.descripcion"
                  >
                    {{ item.datos.descripcion }}
                  </div>

                  <!-- Fila 4: Fecha y Acción Atender -->
                  <div
                    class="d-flex align-center justify-space-between pt-1 incident-card-footer"
                  >
                    <span class="incident-date-text">
                      <v-icon x-small class="mr-1 date-icon"
                        >mdi-calendar</v-icon
                      >
                      {{ formatearFechaIncidente(item) }}
                    </span>
                    <span class="incident-action-link d-flex align-center">
                      <span>Atender</span>
                      <v-icon x-small class="ml-1 action-arrow"
                        >mdi-chevron-right</v-icon
                      >
                    </span>
                  </div>
                </div>
              </template>

              <!-- Estado Vacío -->
              <div
                v-else
                class="incident-empty-container text-center py-6 px-4"
              >
                <div class="incident-empty-icon-circle mb-2">
                  <v-icon color="teal">mdi-check-circle-outline</v-icon>
                </div>
                <div class="incident-empty-title">
                  Sin incidencias pendientes
                </div>
                <div class="incident-empty-desc">
                  No hay tickets o solicitudes de soporte pendientes.
                </div>
              </div>
            </div>

            <!-- Footer con Botón de Actualizar -->
            <div class="incident-footer-actions pa-2">
              <v-btn
                text
                block
                small
                color="teal darken-2"
                class="incident-btn-footer font-weight-bold text-none"
                @click="recargarIncidentes()"
              >
                <v-icon left small>mdi-refresh</v-icon>
                Actualizar Incidencias
              </v-btn>
            </div>
          </div>
        </v-menu>
      </div>
      <!-- ========== FIN BOTONES ACCIÓN sm+ ========== -->

      <!-- ========== MENÚ MÓVIL (xs only): agrupa todos los botones de acción ========== -->
      <v-menu
        offset-y
        origin="top right"
        transition="scale-transition"
        content-class="mobile-actions-menu"
        max-width="300"
        min-width="260"
        class="d-flex d-sm-none"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            icon
            v-bind="attrs"
            v-on="on"
            class="bar-action-btn d-flex d-sm-none"
            aria-label="Notificaciones"
          >
            <v-badge
              dot
              :value="mobileBadgeCount > 0"
              color="red darken-2"
              overlap
            >
              <v-icon>mdi-bell-outline</v-icon>
            </v-badge>
          </v-btn>
        </template>

        <div class="mobile-actions-card">
          <div class="mobile-actions-header px-4 py-2">
            <span
              class="text-caption font-weight-bold text-uppercase"
              style="letter-spacing: 0.6px; color: #94a3b8"
              >Acciones rápidas</span
            >
          </div>
          <v-divider></v-divider>

          <!-- RUC: copiar en móvil -->
          <div
            v-if="clienteRuc"
            class="mobile-action-item"
            @click="copiarRuc(clienteRuc)"
          >
            <v-icon
              small
              class="mr-3"
              :color="rucCopied ? '#34d399' : '#38bdf8'"
            >
              {{ rucCopied ? "mdi-check-circle" : "mdi-content-copy" }}
            </v-icon>
            <div class="mobile-action-content">
              <div class="mobile-action-title">
                {{ rucCopied ? "¡Copiado!" : "Copiar RUC" }}
              </div>
              <div class="mobile-action-subtitle">{{ clienteRuc }}</div>
            </div>
          </div>

          <v-divider class="my-1" v-if="clienteRuc"></v-divider>

          <!-- Reportes Administrativos -->
          <div
            v-if="roleeee == 1 || roleeee == 2"
            class="mobile-action-item"
            @click="$router.push('/reportes')"
          >
            <v-badge
              :content="adminreportescount.length || '0'"
              :value="adminreportescount.length > 0"
              color="amber darken-2"
              overlap
              class="mr-3"
            >
              <v-icon
                small
                :color="
                  adminreportescount.length > 0 ? 'amber lighten-2' : '#94a3b8'
                "
                >mdi-file-document-outline</v-icon
              >
            </v-badge>
            <div class="mobile-action-content">
              <div class="mobile-action-title">Reportes por Aprobar</div>
              <div class="mobile-action-subtitle">
                {{ adminreportescount.length }} pendiente(s)
              </div>
            </div>
          </div>

          <!-- Próximos a Reencauchar -->
          <div v-if="hasClientId" class="mobile-action-item">
            <v-badge
              :content="itemsneuproxreencauchar.length || '0'"
              :value="itemsneuproxreencauchar.length > 0"
              color="orange darken-2"
              overlap
              class="mr-3"
            >
              <v-icon
                small
                :color="
                  itemsneuproxreencauchar.length > 0
                    ? 'orange lighten-2'
                    : '#94a3b8'
                "
                >mdi-tire</v-icon
              >
            </v-badge>
            <div class="mobile-action-content">
              <div class="mobile-action-title">Próximos a Reencauchar</div>
              <div class="mobile-action-subtitle">
                {{ itemsneuproxreencauchar.length }} en alerta
              </div>
            </div>
          </div>

          <!-- Neumáticos a Reencauchar Críticos -->
          <div v-if="hasClientId" class="mobile-action-item">
            <v-badge
              :content="itemsneureencauchar.length || '0'"
              :value="itemsneureencauchar.length > 0"
              color="red darken-2"
              overlap
              class="mr-3"
            >
              <v-icon
                small
                :color="
                  itemsneureencauchar.length > 0 ? 'red lighten-2' : '#94a3b8'
                "
                >mdi-car-tire-alert</v-icon
              >
            </v-badge>
            <div class="mobile-action-content">
              <div class="mobile-action-title">Reencauche Crítico</div>
              <div class="mobile-action-subtitle">
                {{ itemsneureencauchar.length }} crítico(s)
              </div>
            </div>
          </div>

          <!-- Incidencias / Soporte -->
          <div
            v-if="mostraricononotificaciones == true"
            class="mobile-action-item"
            @click="abrirUrlSoporte()"
          >
            <v-icon small class="mr-3" color="#94a3b8">mdi-headset</v-icon>
            <div class="mobile-action-content">
              <div class="mobile-action-title">Reportar Incidencia</div>
              <div class="mobile-action-subtitle">Contactar soporte</div>
            </div>
          </div>
          <div
            v-if="mostraricononotificaciones == false"
            class="mobile-action-item"
          >
            <v-badge
              :content="listaIncidentes.length || '0'"
              :value="listaIncidentes.length > 0"
              color="teal darken-1"
              overlap
              class="mr-3"
            >
              <v-icon
                small
                :color="
                  listaIncidentes.length > 0 ? 'teal lighten-3' : '#94a3b8'
                "
                >mdi-headset</v-icon
              >
            </v-badge>
            <div class="mobile-action-content">
              <div class="mobile-action-title">Incidencias de Soporte</div>
              <div class="mobile-action-subtitle">
                {{ listaIncidentes.length }} pendiente(s)
              </div>
            </div>
          </div>
        </div>
      </v-menu>
      <!-- ========== FIN MENÚ MÓVIL ========== -->

      <!-- Menú Desplegable Opciones y Perfil -->
      <v-menu
        offset-y
        origin="top right"
        transition="scale-transition"
        content-class="options-dropdown-menu"
        min-width="260"
        max-width="300"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            icon
            v-bind="attrs"
            v-on="on"
            class="bar-action-btn"
            aria-label="Opciones"
          >
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>

        <div class="options-menu-card">
          <!-- Lista de Selectores / Opciones -->
          <div class="options-menu-body pa-2">
            <!-- Descargar App Móvil -->
            <div
              v-if="apkDescarga"
              @click="Dowloadapp(apkDescarga.nombreapk)"
              class="option-item-card option-download-item"
              role="button"
            >
              <div class="option-icon-wrap wrap-primary mr-3">
                <v-icon small color="primary">{{
                  apkDescarga.icon || "mdi-cellphone-arrow-down"
                }}</v-icon>
              </div>
              <div class="option-content flex-grow-1 mr-2 text-truncate">
                <div class="d-flex align-center justify-space-between">
                  <span class="option-title">{{
                    apkDescarga.text || "Descargar App"
                  }}</span>
                  <span class="option-version-tag" v-if="apkDescarga.version">
                    {{
                      apkDescarga.version.toLowerCase().startsWith("v")
                        ? apkDescarga.version
                        : "v" + apkDescarga.version
                    }}
                  </span>
                </div>
                <div class="option-subtitle text-truncate">
                  {{ apkDescarga.subtitle || "App móvil para Android" }}
                </div>
              </div>
              <v-icon x-small class="option-arrow">mdi-download</v-icon>
            </div>

            <div v-if="apkDescarga" class="options-divider my-1"></div>

            <!-- Cerrar la Sesión -->
            <div
              v-for="(item, i) in items"
              :key="i"
              @click="Logout()"
              class="option-item-card option-logout-item"
              role="button"
            >
              <div class="option-icon-wrap wrap-danger mr-3">
                <v-icon small color="error">{{
                  item.icon || "mdi-logout-variant"
                }}</v-icon>
              </div>
              <div class="option-content flex-grow-1 mr-2 text-truncate">
                <div class="option-title danger--text">{{ item.text }}</div>
                <div class="option-subtitle text-truncate">
                  {{ item.subtitle || "Cerrar y salir del sistema" }}
                </div>
              </div>
              <v-icon x-small class="option-arrow arrow-danger"
                >mdi-chevron-right</v-icon
              >
            </div>
          </div>
        </div>
      </v-menu>
    </v-app-bar>
    <FormularioIncidencias
      :dialog="dialogformularioincidencia"
      v-if="verformularioincidencia"
      @cerrarModalIncidencias="cerrarModalIncidencias"
    />
    <FormularioRespuestaIncidencias
      :dialog="dialogformulariorespuestaincidencia"
      v-if="verformulariorespuestaincidencia"
      @cerrarModalRespuestaIncidencias="cerrarModalRespuestaIncidencias"
      :datos="datos"
    />
    <FormularioModeloMedida
      :dialog="dialogformularioModeloMedida"
      v-if="verformularioModeloMedida"
      @cerrarModalModeloMedidas="cerrarModalModeloMedidas"
    />

    <!-- Overlay de carga centrado al acceder a cliente -->
    <v-overlay
      :value="cargandoAccesoCliente"
      z-index="99999"
      opacity="0.8"
      color="#0f172a"
    >
      <div class="report-loading-card text-center pa-6 rounded-xl elevation-12">
        <div class="mb-4 d-flex justify-center">
          <v-progress-circular
            indeterminate
            size="64"
            width="5"
            color="amber darken-2"
          ></v-progress-circular>
        </div>
        <div class="report-loading-title font-weight-bold mb-1">
          Accediendo al Cliente
        </div>
        <div class="report-loading-subtitle mb-2" v-if="nombreClienteCargando">
          {{ nombreClienteCargando }}
        </div>
        <div class="report-loading-desc">
          Configurando entorno y cargando reportes...
        </div>
      </div>
    </v-overlay>

    <!-- Snackbar Notificación RUC Copiado -->
    <v-snackbar
      v-model="snackbarRuc"
      :timeout="2200"
      top
      right
      color="#0f172a"
      elevation="8"
      class="topbar-custom-snackbar"
    >
      <div class="d-flex align-center">
        <v-icon color="#34d399" class="mr-2" small>mdi-check-circle</v-icon>
        <span class="text-caption font-weight-medium white--text">
          RUC
          <strong class="cyan--text text--lighten-2">{{ clienteRuc }}</strong>
          copiado al portapapeles
        </span>
      </div>
    </v-snackbar>
  </div>
</template>
<style>
/* Barra Superior con degradado elegante a juego con Navigation */
.custom-top-bar {
  background: linear-gradient(135deg, #1e293b 0%, #0f172a 100%) !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08) !important;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15) !important;
}

.custom-top-bar .v-btn--icon {
  border-radius: 8px !important;
  transition: all 0.25s ease !important;
}

.custom-top-bar .v-btn--icon:hover {
  background-color: rgba(255, 255, 255, 0.1) !important;
  transform: translateY(-1px);
}

/* Menú de Opciones Moderno */
.custom-options-menu {
  border-radius: 12px !important;
  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.18),
    0 8px 10px -6px rgba(0, 0, 0, 0.1) !important;
  border: 1px solid rgba(0, 0, 0, 0.08) !important;
  overflow: hidden !important;
}

.options-list {
  background: #ffffff !important;
}

.options-list-item {
  min-height: 42px !important;
  border-radius: 8px !important;
  margin: 2px 4px !important;
  cursor: pointer !important;
  transition: all 0.2s ease !important;
}

.options-list-item:hover {
  background-color: #f1f5f9 !important;
  transform: translateX(2px);
}

.options-item-title {
  font-size: 14px !important;
  color: #334155;
  letter-spacing: 0.01em;
}

.version-badge {
  display: inline-block;
  background-color: #dcfce7;
  color: #15803d;
  font-size: 12px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 6px;
}

.scrollable-list {
  max-height: 275px;
  /* Altura máxima del listado */
  overflow-y: auto;
  /* Habilitar el desplazamiento vertical */
}

.v-application--is-ltr .custom-badge .v-badge__badge {
  inset: auto auto calc(100% - 20px) calc(100% - 20px) !important;
}

.custom-badge .v-badge__badge {
  border-radius: 10px;
  color: #fff;
  font-size: 10px !important;
  height: 16px !important;
  letter-spacing: 0;
  min-width: 20px;
  padding: 3px 5px !important;
  pointer-events: auto;
  position: absolute;
  text-align: center;
  text-indent: 0;
  top: auto;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
  white-space: nowrap;
}

.hover-effect {
  transition: background-color 0.3s ease;
}

/* Hover effect */
.hover-effect:hover {
  background-color: #f0f0f0 !important;
  /* Gris claro */
}

/* Cambiar el color del porcentaje */
.hover-effect .text-right span {
  color: grey !important;
  /* Cambia el color a gris */
}

/* ==========================================================
   Menú Desplegable Moderno - Reportes por Aprobar
   ========================================================== */
.report-dropdown-menu {
  border-radius: 14px !important;
  box-shadow: 0 16px 36px -4px rgba(15, 23, 42, 0.18),
    0 6px 14px -2px rgba(15, 23, 42, 0.08) !important;
  border: 1px solid #e2e8f0 !important;
  overflow: hidden !important;
  background: #ffffff !important;
}

.report-menu-card {
  background: #ffffff;
  display: flex;
  flex-direction: column;
}

.report-menu-header {
  background: #f8fafc;
  border-bottom: 1px solid #edf2f7;
}

.report-header-avatar {
  width: 34px;
  height: 34px;
  border-radius: 10px;
  background: #fef3c7;
  display: flex;
  align-items: center;
  justify-content: center;
}

.report-menu-title {
  font-size: 13.5px;
  font-weight: 700;
  color: #0f172a;
  letter-spacing: -0.01em;
  line-height: 1.2;
}

.report-menu-subtitle {
  font-size: 11px;
  color: #64748b;
  margin-top: 1px;
}

.report-count-pill {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 9999px;
  font-size: 11px;
  font-weight: 600;
  background: #fef3c7;
  color: #b45309;
  border: 1px solid #fde68a;
}

.report-scroll-container {
  max-height: 320px;
  overflow-y: auto;
  padding: 8px 10px;
}

/* Scrollbar estilizado */
.report-scroll-container::-webkit-scrollbar {
  width: 5px;
}
.report-scroll-container::-webkit-scrollbar-track {
  background: #f8fafc;
}
.report-scroll-container::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 4px;
}
.report-scroll-container::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

/* Tarjeta individual de reporte */
.report-card-item {
  position: relative;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 10px 12px;
  margin-bottom: 8px;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.report-card-item:hover {
  background: #f8fafc;
  border-color: #cbd5e1;
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.06);
  transform: translateY(-1px);
}

.report-card-item:hover .action-arrow {
  transform: translateX(3px);
}

/* Borde lateral distintivo según estado */
.report-status-border-proceso {
  border-left: 4px solid #f59e0b !important;
}

.report-status-border-rechazado {
  border-left: 4px solid #ef4444 !important;
}

.report-status-border-aprobado {
  border-left: 4px solid #10b981 !important;
}

/* Cliente */
.report-client-name {
  font-size: 13px;
  font-weight: 600;
  color: #1e293b;
  display: flex;
  align-items: center;
}

.report-client-name .client-icon {
  color: #3b82f6 !important;
}

/* Badges de Estado */
.report-badge-status {
  display: inline-flex;
  align-items: center;
  padding: 2px 7px;
  border-radius: 6px;
  font-size: 10.5px;
  font-weight: 600;
  letter-spacing: 0.02em;
  white-space: nowrap;
}

.status-badge-process {
  background-color: #fffbeb;
  color: #b45309;
  border: 1px solid #fde68a;
}

.status-badge-rejected {
  background-color: #fef2f2;
  color: #b91c1c;
  border: 1px solid #fecaca;
}

.status-badge-approved {
  background-color: #ecfdf5;
  color: #047857;
  border: 1px solid #a7f3d0;
}

.status-badge-default {
  background-color: #f1f5f9;
  color: #475569;
  border: 1px solid #e2e8f0;
}

/* Metadatos */
.report-meta-row {
  font-size: 11.5px;
  color: #475569;
}

.report-meta-item {
  display: inline-flex;
  align-items: center;
}

.meta-icon,
.date-icon {
  color: #94a3b8 !important;
}

.report-card-footer {
  border-top: 1px dashed #f1f5f9;
  margin-top: 4px;
}

.report-date-text {
  font-size: 11px;
  color: #64748b;
  display: inline-flex;
  align-items: center;
}

.report-action-link {
  font-size: 11px;
  font-weight: 600;
  color: #2563eb;
  transition: all 0.2s ease;
}

.action-arrow {
  transition: transform 0.2s ease;
}

/* Estado Vacío */
.report-empty-container {
  background: #ffffff;
}

.report-empty-icon-circle {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: #ecfdf5;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
}

.report-empty-title {
  font-size: 13px;
  font-weight: 600;
  color: #1e293b;
}

.report-empty-desc {
  font-size: 11px;
  color: #64748b;
}

/* Footer con acción */
.report-footer-actions {
  background: #f8fafc;
  border-top: 1px solid #edf2f7;
}

.report-btn-view-all {
  border-radius: 8px !important;
}

/* ==========================================================
   Menú Desplegable Moderno - Incidencias de Soporte
   ========================================================== */
.incident-dropdown-menu {
  border-radius: 14px !important;
  box-shadow: 0 16px 36px -4px rgba(15, 23, 42, 0.18),
    0 6px 14px -2px rgba(15, 23, 42, 0.08) !important;
  border: 1px solid #e2e8f0 !important;
  overflow: hidden !important;
  background: #ffffff !important;
}

.incident-menu-card {
  background: #ffffff;
  display: flex;
  flex-direction: column;
}

.incident-menu-header {
  background: #f8fafc;
  border-bottom: 1px solid #edf2f7;
}

.incident-header-avatar {
  width: 34px;
  height: 34px;
  border-radius: 10px;
  background: #ccfbf1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.incident-menu-title {
  font-size: 13.5px;
  font-weight: 700;
  color: #0f172a;
  letter-spacing: -0.01em;
  line-height: 1.2;
}

.incident-menu-subtitle {
  font-size: 11px;
  color: #64748b;
  margin-top: 1px;
}

.incident-count-pill {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 9999px;
  font-size: 11px;
  font-weight: 600;
  background: #ccfbf1;
  color: #0f766e;
  border: 1px solid #99f6e4;
}

.incident-scroll-container {
  max-height: 330px;
  overflow-y: auto;
  padding: 8px 10px;
}

.incident-scroll-container::-webkit-scrollbar {
  width: 5px;
}
.incident-scroll-container::-webkit-scrollbar-track {
  background: #f8fafc;
}
.incident-scroll-container::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 4px;
}
.incident-scroll-container::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

/* Tarjeta individual de incidencia */
.incident-card-item {
  position: relative;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 10px 12px;
  margin-bottom: 8px;
  cursor: pointer;
  border-left: 4px solid #0d9488 !important;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.incident-card-item:hover {
  background: #f8fafc;
  border-color: #cbd5e1;
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.06);
  transform: translateY(-1px);
}

.incident-card-item:hover .action-arrow {
  transform: translateX(3px);
}

.incident-ticket-title {
  font-size: 12.5px;
  font-weight: 700;
  color: #0f172a;
}

.incident-client-name {
  font-size: 12px;
  font-weight: 600;
  color: #334155;
  display: flex;
  align-items: center;
}

.incident-client-name .client-icon {
  color: #0284c7 !important;
}

.incident-user-name {
  font-size: 11.5px;
  color: #64748b;
  display: flex;
  align-items: center;
}

.incident-desc-text {
  font-size: 11.5px;
  color: #475569;
  line-height: 1.35;
  margin-bottom: 4px;
}

.text-truncate-2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.incident-badge-status {
  display: inline-flex;
  align-items: center;
  padding: 2px 7px;
  border-radius: 6px;
  font-size: 10.5px;
  font-weight: 600;
  letter-spacing: 0.02em;
  white-space: nowrap;
}

.status-badge-pending {
  background-color: #f0fdf4;
  color: #166534;
  border: 1px solid #bbf7d0;
}

.incident-card-footer {
  border-top: 1px dashed #f1f5f9;
  margin-top: 4px;
}

.incident-date-text {
  font-size: 11px;
  color: #64748b;
  display: inline-flex;
  align-items: center;
}

.incident-action-link {
  font-size: 11px;
  font-weight: 600;
  color: #0d9488;
  transition: all 0.2s ease;
}

/* Estado Vacío */
.incident-empty-container {
  background: #ffffff;
}

.incident-empty-icon-circle {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: #ccfbf1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
}

.incident-empty-title {
  font-size: 13px;
  font-weight: 600;
  color: #1e293b;
}

.incident-empty-desc {
  font-size: 11px;
  color: #64748b;
}

.incident-footer-actions {
  background: #f8fafc;
  border-top: 1px solid #edf2f7;
}

.incident-btn-footer {
  border-radius: 8px !important;
}

/* ==========================================================
   Loading Overlay al acceder a cliente
   ========================================================== */
.report-loading-card {
  background: rgba(30, 41, 59, 0.95);
  border: 1px solid rgba(255, 255, 255, 0.15);
  box-shadow: 0 20px 40px -8px rgba(0, 0, 0, 0.6),
    0 0 25px rgba(245, 158, 11, 0.2);
  backdrop-filter: blur(8px);
  min-width: 290px;
  max-width: 360px;
}

.report-loading-title {
  font-size: 16px;
  color: #f8fafc;
  letter-spacing: -0.01em;
}

.report-loading-subtitle {
  font-size: 13.5px;
  font-weight: 600;
  color: #fbbf24;
}

.report-loading-desc {
  font-size: 12px;
  color: #94a3b8;
}

/* ==========================================================
   Menús Desplegables Modernos - Neumáticos a Reencauchar y Próximos
   ========================================================== */
.prox-reencauche-dropdown-menu,
.reencauche-dropdown-menu {
  border-radius: 14px !important;
  box-shadow: 0 16px 36px -4px rgba(15, 23, 42, 0.18),
    0 6px 14px -2px rgba(15, 23, 42, 0.08) !important;
  border: 1px solid #e2e8f0 !important;
  overflow: hidden !important;
  background: #ffffff !important;
}

.neu-menu-card {
  background: #ffffff;
  display: flex;
  flex-direction: column;
}

.neu-menu-header {
  background: #f8fafc;
  border-bottom: 1px solid #edf2f7;
}

.neu-header-avatar {
  width: 34px;
  height: 34px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.avatar-orange {
  background: #ffedd5;
}

.avatar-red {
  background: #fee2e2;
}

.neu-menu-title {
  font-size: 13.5px;
  font-weight: 700;
  color: #0f172a;
  letter-spacing: -0.01em;
  line-height: 1.2;
}

.neu-menu-subtitle {
  font-size: 11px;
  color: #64748b;
  margin-top: 1px;
}

.neu-count-pill {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 9999px;
  font-size: 11px;
  font-weight: 600;
}

.pill-orange {
  background: #ffedd5;
  color: #c2410c;
  border: 1px solid #fed7aa;
}

.pill-red {
  background: #fee2e2;
  color: #b91c1c;
  border: 1px solid #fecaca;
}

.neu-scroll-container {
  max-height: 330px;
  overflow-y: auto;
  padding: 8px 10px;
}

.neu-scroll-container::-webkit-scrollbar {
  width: 5px;
}
.neu-scroll-container::-webkit-scrollbar-track {
  background: #f8fafc;
}
.neu-scroll-container::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 4px;
}
.neu-scroll-container::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

/* Tarjeta de Neumático */
.neu-card-item {
  position: relative;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  padding: 10px 12px;
  margin-bottom: 8px;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.neu-card-item:hover {
  background: #f8fafc;
  border-color: #cbd5e1;
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.06);
  transform: translateY(-1px);
}

.neu-card-item:hover .action-arrow {
  transform: translateX(3px);
}

.card-border-orange {
  border-left: 4px solid #f97316 !important;
}

.card-border-red {
  border-left: 4px solid #ef4444 !important;
}

.neu-serial-title {
  font-size: 12.5px;
  color: #0f172a;
}

.neu-brand-badge {
  font-size: 10.5px;
  font-weight: 600;
  padding: 1px 6px;
  background: #f1f5f9;
  color: #475569;
  border-radius: 4px;
  border: 1px solid #e2e8f0;
}

.neu-status-pill-red {
  display: inline-flex;
  align-items: center;
  padding: 2px 7px;
  border-radius: 6px;
  font-size: 10.5px;
  font-weight: 700;
  background-color: #fef2f2;
  color: #b91c1c;
  border: 1px solid #fecaca;
}

.neu-meta-text {
  font-size: 11.5px;
  color: #475569;
}

.neu-percentage-orange {
  color: #ea580c;
  font-size: 12.5px;
}

.neu-progress-section {
  background: #fffaf5;
  border: 1px solid #ffedd5;
  border-radius: 8px;
  padding: 6px 8px;
}

.neu-rem-grid {
  background: #fef2f2;
  border: 1px solid #fee2e2;
}

.neu-rem-text {
  font-size: 11px;
  color: #64748b;
  display: inline-flex;
  align-items: center;
}

.neu-card-footer {
  border-top: 1px dashed #f1f5f9;
  margin-top: 4px;
}

.neu-action-link {
  font-size: 11px;
  font-weight: 600;
  transition: all 0.2s ease;
}

.link-orange {
  color: #ea580c;
}

.link-red {
  color: #dc2626;
}

/* Estado Vacío */
.neu-empty-container {
  background: #ffffff;
}

.neu-empty-icon-circle {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: #ecfdf5;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
}

.neu-empty-title {
  font-size: 13px;
  font-weight: 600;
  color: #1e293b;
}

.neu-empty-desc {
  font-size: 11px;
  color: #64748b;
}

.neu-footer-actions {
  background: #f8fafc;
  border-top: 1px solid #edf2f7;
}

.neu-btn-footer {
  border-radius: 8px !important;
}

/* ==========================================================
   Menú Desplegable Moderno - Opciones y Perfil
   ========================================================== */
.options-dropdown-menu {
  border-radius: 14px !important;
  box-shadow: 0 16px 36px -4px rgba(15, 23, 42, 0.18),
    0 6px 14px -2px rgba(15, 23, 42, 0.08) !important;
  border: 1px solid #e2e8f0 !important;
  overflow: hidden !important;
  background: #ffffff !important;
}

.options-menu-card {
  background: #ffffff;
  display: flex;
  flex-direction: column;
}

.options-menu-header {
  background: #f8fafc;
  border-bottom: 1px solid #edf2f7;
}

.options-header-avatar {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: #eff6ff;
  border: 1px solid #dbeafe;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.options-header-title {
  font-size: 13px;
  font-weight: 700;
  color: #0f172a;
  letter-spacing: -0.01em;
  line-height: 1.25;
}

.options-role-badge {
  display: inline-flex;
  align-items: center;
  padding: 1px 7px;
  border-radius: 9999px;
  font-size: 10.5px;
  font-weight: 600;
  background: #f1f5f9;
  color: #475569;
  border: 1px solid #e2e8f0;
}

.options-menu-body {
  background: #ffffff;
}

/* Tarjeta interactiva de opción */
.option-item-card {
  display: flex;
  align-items: center;
  padding: 8px 10px;
  border-radius: 10px;
  cursor: pointer;
  border: 1px solid transparent;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  user-select: none;
}

.option-item-card:hover {
  background: #f8fafc;
  border-color: #e2e8f0;
  transform: translateX(2px);
}

.option-item-card:hover .option-arrow {
  transform: translateX(2px);
  color: #1e293b !important;
}

.option-icon-wrap {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: all 0.2s ease;
}

.wrap-primary {
  background: #eff6ff;
  border: 1px solid #dbeafe;
}

.wrap-info {
  background: #f0f9ff;
  border: 1px solid #e0f2fe;
}

.wrap-danger {
  background: #fef2f2;
  border: 1px solid #fee2e2;
}

/* ==========================================================================
   TOPBAR CLIENT & RUC BADGE STYLES (DISEÑO HORIZONTAL UI/UX)
   ========================================================================== */

.topbar-client-wrapper {
  user-select: none;
  max-width: calc(100vw - 230px);
}

.topbar-client-card {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(8px);
  border-radius: 9px;
  padding: 4px 8px 4px 6px;
  gap: 8px;
  transition: all 0.22s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  flex-wrap: nowrap;
}

.topbar-client-card:hover {
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(56, 189, 248, 0.35);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.25);
}

/* Avatar / Logo */
.topbar-client-avatar {
  width: 26px;
  height: 26px;
  min-width: 26px;
  border-radius: 6px;
  background: linear-gradient(
    135deg,
    rgba(56, 189, 248, 0.15) 0%,
    rgba(99, 102, 241, 0.15) 100%
  );
  border: 1px solid rgba(56, 189, 248, 0.28);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: visible;
}

.topbar-client-img {
  width: 100%;
  height: 100%;
  border-radius: 5px;
  object-fit: cover;
}

/* Punto indicador de sesión activa */
.topbar-client-status-dot {
  position: absolute;
  bottom: -1px;
  right: -1px;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #10b981;
  border: 1px solid #0f172a;
  box-shadow: 0 0 6px rgba(16, 185, 129, 0.8);
  animation: pulse-dot 2.5s infinite;
}

@keyframes pulse-dot {
  0% {
    box-shadow: 0 0 0 0 rgba(16, 185, 129, 0.7);
  }
  70% {
    box-shadow: 0 0 0 5px rgba(16, 185, 129, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(16, 185, 129, 0);
  }
}

/* Pill de RUC (Horizontal: Primero) */
.topbar-ruc-pill {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: rgba(56, 189, 248, 0.12);
  border: 1px solid rgba(56, 189, 248, 0.28);
  padding: 2.5px 8px;
  border-radius: 6px;
  font-size: 12.5px;
  color: #e2e8f0;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
}

.topbar-ruc-pill:hover {
  background: rgba(56, 189, 248, 0.24);
  border-color: rgba(56, 189, 248, 0.55);
  color: #ffffff;
  transform: translateY(-1px);
}

.topbar-ruc-pill.copied {
  background: rgba(16, 185, 129, 0.22);
  border-color: rgba(16, 185, 129, 0.65);
  color: #a7f3d0;
}

.topbar-ruc-tag {
  font-size: 10px;
  font-weight: 700;
  color: #38bdf8;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.topbar-ruc-pill.copied .topbar-ruc-tag {
  color: #34d399;
}

.topbar-ruc-num {
  font-weight: 600;
  font-size: 12.5px;
  font-family: monospace, ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas;
  letter-spacing: 0.03em;
}

.topbar-ruc-copy-icon {
  font-size: 12px !important;
  opacity: 0.8;
  transition: opacity 0.2s;
}

.topbar-ruc-pill:hover .topbar-ruc-copy-icon {
  opacity: 1;
}

/* Divisor sutil */
.topbar-client-divider {
  width: 1px;
  height: 16px;
  background: rgba(255, 255, 255, 0.15);
  margin: 0 1px;
}

/* Razón Social (Horizontal: Segundo) */
.topbar-client-name-wrap {
  cursor: default;
  max-width: 280px;
}

.topbar-client-name {
  font-size: 14.5px;
  font-weight: 600;
  color: #f8fafc;
  letter-spacing: 0.01em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.topbar-client-slug {
  background: rgba(99, 102, 241, 0.2);
  color: #a5b4fc;
  border: 1px solid rgba(99, 102, 241, 0.35);
  padding: 1px 6px;
  border-radius: 4px;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  white-space: nowrap;
}

/* Tooltip Custom */
.topbar-client-tooltip {
  background: rgba(15, 23, 42, 0.96) !important;
  border: 1px solid rgba(255, 255, 255, 0.12) !important;
  border-radius: 8px !important;
  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.5) !important;
  font-size: 12px !important;
}

/* Snackbar Custom */
.topbar-custom-snackbar .v-snack__wrapper {
  border: 1px solid rgba(56, 189, 248, 0.3) !important;
  border-radius: 8px !important;
}

/* Media Queries para Adaptación Responsive */
@media (max-width: 1200px) {
  .topbar-client-name-wrap {
    max-width: 220px;
  }
}

@media (max-width: 960px) {
  .topbar-client-wrapper {
    max-width: calc(100vw - 210px);
  }
  .topbar-client-name-wrap {
    max-width: 170px;
  }
  .topbar-client-card {
    gap: 6px;
    padding: 3px 6px 3px 5px;
  }
  .topbar-client-name {
    font-size: 13.5px;
  }
  .topbar-ruc-num {
    font-size: 11.5px;
  }
}

@media (max-width: 768px) {
  .topbar-client-wrapper {
    max-width: calc(100vw - 190px);
  }
  .topbar-client-name-wrap {
    max-width: 140px;
  }
  .topbar-client-name {
    font-size: 13px;
  }
  .topbar-ruc-pill {
    padding: 2px 6px;
    font-size: 11px;
  }
  .topbar-ruc-num {
    font-size: 11px;
  }
}

@media (max-width: 600px) {
  .topbar-client-wrapper {
    max-width: calc(100vw - 170px);
  }
  .topbar-client-card {
    gap: 5px;
    padding: 2px 5px 2px 4px;
  }
  .topbar-client-avatar {
    width: 22px;
    height: 22px;
    min-width: 22px;
  }
  .topbar-ruc-pill {
    padding: 1.5px 5px;
    font-size: 10.5px;
    gap: 2px;
  }
  .topbar-ruc-tag {
    font-size: 8.5px;
  }
  .topbar-ruc-num {
    font-size: 10.5px;
  }
  .topbar-client-name-wrap {
    max-width: 110px;
  }
  .topbar-client-name {
    font-size: 12px;
  }
}

@media (max-width: 420px) {
  .topbar-client-avatar {
    display: none;
  }
  .topbar-client-name-wrap {
    max-width: 80px;
  }
}

.option-title {
  font-size: 12.5px;
  font-weight: 600;
  color: #1e293b;
  line-height: 1.2;
}

.danger--text {
  color: #dc2626 !important;
}

.option-subtitle {
  font-size: 11px;
  color: #64748b;
  margin-top: 1px;
  line-height: 1.2;
}

.option-version-tag {
  display: inline-flex;
  align-items: center;
  padding: 1px 6px;
  border-radius: 6px;
  font-size: 10px;
  font-weight: 700;
  background: #ecfdf5;
  color: #047857;
  border: 1px solid #a7f3d0;
  letter-spacing: 0.02em;
}

.option-arrow {
  color: #94a3b8 !important;
  transition: transform 0.2s ease, color 0.2s ease;
}

.arrow-danger {
  color: #f87171 !important;
}

.option-logout-item:hover {
  background: #fef2f2 !important;
  border-color: #fecaca !important;
}

.option-logout-item:hover .arrow-danger {
  color: #dc2626 !important;
}

.options-divider {
  height: 1px;
  background: #f1f5f9;
  margin: 4px 6px;
}

/* ---- Nombre abreviado en móvil ---- */
.topbar-name-mobile {
  font-size: 0.8rem !important;
  font-weight: 600 !important;
  max-width: 120px;
}

/* ---- Menú móvil de acciones rápidas ---- */
.mobile-actions-menu {
  border-radius: 12px !important;
  overflow: hidden;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.35) !important;
}

.mobile-actions-card {
  background: #1e293b;
  border-radius: 12px;
  overflow: hidden;
  min-width: 260px;
}

.mobile-actions-header {
  background: rgba(255, 255, 255, 0.04);
}

.mobile-action-item {
  display: flex;
  align-items: center;
  padding: 10px 16px;
  cursor: pointer;
  transition: background-color 0.15s ease;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}

.mobile-action-item:last-child {
  border-bottom: none;
}

.mobile-action-item:hover {
  background: rgba(255, 255, 255, 0.08);
}

.mobile-action-content {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.mobile-action-title {
  font-size: 0.82rem;
  font-weight: 600;
  color: #f1f5f9;
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.mobile-action-subtitle {
  font-size: 0.72rem;
  color: #64748b;
  line-height: 1.2;
  margin-top: 1px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
<script>
import { mapGetters, mapActions, mapState } from "vuex";
import FormularioIncidencias from "@/components/incidencias/nuevo.vue";
import FormularioRespuestaIncidencias from "@/components/incidencias/respuesta.vue";
import FormularioModeloMedida from "@/components/indicador/nuevo.vue";
import moment from "moment";

export default {
  props: ["drawer"],
  components: {
    FormularioIncidencias,
    FormularioModeloMedida,
    FormularioRespuestaIncidencias,
  },
  data: () => ({
    selectedItem: 1,
    items: [
      {
        text: "Cerrar la sesión",
        subtitle: "Finalizar tu sesión en el sistema",
        icon: "mdi-logout-variant",
        funcion: "Logout",
      },
    ],
    dowloads: [
      {
        text: "Descargar App Móvil",
        subtitle: "App Android para operaciones",
        icon: "mdi-cellphone-arrow-down",
        funcion: "Dowloadapp",
        version: "tiresoft-2.5",
        nombreapk: "tiresoft-production.apk",
      },
    ],
    notificaciones: [],
    cantidadincidentes: 0,
    dialogformularioincidencia: false,
    verformularioincidencia: false,
    mostraricononotificaciones: false,
    mostrarcomponentenotificaciones: false,
    mostrarnotificaciones: false,
    cant_cost_kilo: 0,
    cant_cost_hora: 0,
    cant_indi_reencauche: 0,
    cant_indi_reencauchabilidad: 0,
    cant_reportes: 0,
    dialogformularioModeloMedida: false,
    verformularioModeloMedida: false,
    roleeee: 0,
    dialogformulariorespuestaincidencia: false,
    verformulariorespuestaincidencia: false,
    datos: [],
    cargandoAccesoCliente: false,
    nombreClienteCargando: "",
    rucCopied: false,
    rucCopyTimer: null,
    snackbarRuc: false,
  }),
  computed: {
    ...mapState("incidente", ["Incidentes"]),
    ...mapState("cliente", ["Cliente", "ClientesUsuario"]),
    ...mapState("versionapk", ["Download"]),
    ...mapState("neumatico", [
      "itemsneureencauchar",
      "itemsneuproxreencauchar",
      "criterios_",
      "adminreportescount",
    ]),
    ...mapGetters("navigation", ["Mini"]),
    userRole() {
      return localStorage.getItem("role") || "";
    },
    userEmail() {
      return localStorage.getItem("email") || "";
    },
    apkDescarga() {
      if (this.Download && this.Download.nombreapk) {
        return this.Download;
      }
      return this.dowloads && this.dowloads.length > 0
        ? this.dowloads[0]
        : null;
    },
    hasClientId() {
      return (
        sessionStorage.getItem("id_cliente_seleccionado") !== null ||
        sessionStorage.getItem("idcliente") !== null ||
        localStorage.getItem("idcliente") !== null
      );
    },
    listaIncidentes() {
      if (!this.notificaciones || !Array.isArray(this.notificaciones))
        return [];
      return this.notificaciones.filter((n) => !n.header && !n.divider);
    },
    clienteNombreCorto() {
      const nombre = this.clienteRazonSocial;
      if (!nombre || nombre === "Sin cliente seleccionado") return nombre;
      // Tomar las primeras 2 palabras, máximo 14 caracteres
      const palabras = nombre.trim().split(/\s+/);
      let corto = palabras.slice(0, 2).join(" ");
      if (corto.length > 14) corto = corto.substring(0, 13) + "…";
      return corto;
    },
    supportUrl() {
      return (
        process.env.VUE_APP_SUPPORT_URL || "https://elsol.contentmedia.pe/"
      );
    },
    mobileBadgeCount() {
      return (
        (this.adminreportescount ? this.adminreportescount.length : 0) +
        (this.itemsneuproxreencauchar
          ? this.itemsneuproxreencauchar.length
          : 0) +
        (this.itemsneureencauchar ? this.itemsneureencauchar.length : 0) +
        (this.listaIncidentes ? this.listaIncidentes.length : 0)
      );
    },
    clienteRazonSocial() {
      if (this.Cliente && (this.Cliente.razon_social || this.Cliente.name)) {
        return this.Cliente.razon_social || this.Cliente.name;
      }
      return "Sin cliente seleccionado";
    },
    clienteRuc() {
      return this.Cliente && this.Cliente.ruc ? this.Cliente.ruc : null;
    },
    clienteSlug() {
      return this.Cliente && this.Cliente.slug ? this.Cliente.slug : null;
    },
  },
  methods: {
    ...mapActions("navigation", ["Minimizar", "loadRoutes"]),
    ...mapActions("login", ["logout"]),
    ...mapActions("versionapk", ["ObtenerVersionado", "DescargarApk"]),
    ...mapActions("cliente", [
      "ObtenerDatosCliente",
      "guardarAccesoACliente",
      "obtenerClientesPorUsuario",
    ]),
    ...mapActions("incidente", ["cargarIncidentes"]),
    ...mapActions("neumatico", [
      "Neumaticosareencauchar",
      "Neumaticosproxareencauchar",
      "GetCriterios_",
      "Getadminreportescount",
    ]),
    obtenerincidentes() {
      console.log(this.Incidentes, "Incidentes");
      return this.Incidentes;
    },
    mostrarmodal(item) {
      if (item && item.datos) {
        this.datos = item.datos;
        this.openModalRespuestaIncidencias();
      }
    },
    async recargarIncidentes() {
      this.notificaciones = await this.cargarIncidentes();
      this.cantidadincidentes = this.listaIncidentes.length;
    },
    formatearFechaIncidente(item) {
      if (item && item.datos && item.datos.fecha) {
        let f = item.datos.fecha.toString().trim();
        const datePart = f.split(/[ T]/)[0];
        if (/^\d{4}-\d{2}-\d{2}$/.test(datePart)) {
          const [yyyy, mm, dd] = datePart.split("-");
          return `${dd}/${mm}/${yyyy}`;
        }
        const m = moment(f);
        return m.isValid() ? m.format("DD/MM/YYYY") : f;
      }
      return "";
    },
    gomantvehi(id_vehiculo) {
      this.$router.push({ path: `/ubicaciontemporal` });
      setTimeout(() => {
        this.$router.push({ path: `/vehiculo/instalacion/${id_vehiculo}` });
      }, 10); // Usa un retraso mínimo, como 10ms
    },
    async recargarReportes() {
      await this.Getadminreportescount();
    },
    async recargarProxReencauchar() {
      await this.Neumaticosproxareencauchar();
    },
    async recargarReencauchar() {
      await this.Neumaticosareencauchar();
    },
    async redireccionar_reportes(item) {
      let idCliente = item ? item.cliente_id || item.id_cliente : null;

      if (!idCliente && item && (item.razon_social || item.reporte)) {
        const razonBuscada = (item.razon_social || item.reporte)
          .trim()
          .toLowerCase();
        if (!this.ClientesUsuario || this.ClientesUsuario.length === 0) {
          try {
            await this.obtenerClientesPorUsuario();
          } catch (e) {
            console.error("Error al obtener clientes:", e);
          }
        }
        if (this.ClientesUsuario && this.ClientesUsuario.length > 0) {
          const match = this.ClientesUsuario.find((c) => {
            const cName = (c.name || c.razon_social || "").trim().toLowerCase();
            return (
              cName === razonBuscada ||
              razonBuscada.includes(cName) ||
              cName.includes(razonBuscada)
            );
          });
          if (match) {
            idCliente = match.id;
          }
        }
      }

      const clienteActual =
        sessionStorage.getItem("id_cliente_seleccionado") ||
        sessionStorage.getItem("idcliente");

      if (
        idCliente &&
        (String(idCliente) !== String(clienteActual) ||
          !clienteActual ||
          this.$route.path === "/seleccionarCliente")
      ) {
        this.nombreClienteCargando =
          item.razon_social || item.reporte || "Cliente seleccionado";
        this.cargandoAccesoCliente = true;

        sessionStorage.setItem("id_cliente_seleccionado", idCliente);
        sessionStorage.setItem("idcliente", idCliente);
        localStorage.removeItem("idcliente");
        localStorage.removeItem("id_cliente_seleccionado");
        localStorage.removeItem("idclient");

        try {
          await this.guardarAccesoACliente();
          await this.loadRoutes(1);
        } catch (error) {
          console.error("Error configurando acceso a cliente:", error);
        }

        const targetUrl =
          (process.env.BASE_URL || "/").replace(/\/$/, "") +
          "/administracionreportes";
        window.location.href = targetUrl;
        return;
      }

      if (this.$route.path === "/seleccionarCliente") {
        if (!clienteActual) {
          if (!this.ClientesUsuario || this.ClientesUsuario.length === 0) {
            try {
              await this.obtenerClientesPorUsuario();
            } catch (e) {}
          }
          if (this.ClientesUsuario && this.ClientesUsuario.length > 0) {
            const primerCliente = this.ClientesUsuario[0].id;
            this.nombreClienteCargando =
              this.ClientesUsuario[0].name ||
              this.ClientesUsuario[0].razon_social ||
              "";
            this.cargandoAccesoCliente = true;

            sessionStorage.setItem("id_cliente_seleccionado", primerCliente);
            sessionStorage.setItem("idcliente", primerCliente);
            localStorage.removeItem("idcliente");
            localStorage.removeItem("id_cliente_seleccionado");
            localStorage.removeItem("idclient");
            try {
              await this.guardarAccesoACliente();
              await this.loadRoutes(1);
            } catch (e) {}
            const targetUrl =
              (process.env.BASE_URL || "/").replace(/\/$/, "") +
              "/administracionreportes";
            window.location.href = targetUrl;
            return;
          }
        } else {
          this.cargandoAccesoCliente = true;
          const targetUrl =
            (process.env.BASE_URL || "/").replace(/\/$/, "") +
            "/administracionreportes";
          window.location.href = targetUrl;
          return;
        }
      }

      if (this.$route.path !== "/administracionreportes") {
        this.$router.push({ path: "/administracionreportes" }).catch(() => {
          const targetUrl =
            (process.env.BASE_URL || "/").replace(/\/$/, "") +
            "/administracionreportes";
          window.location.href = targetUrl;
        });
      }
    },
    formatearFecha(fecha) {
      if (!fecha) return "-";
      const m = moment(fecha);
      return m.isValid() ? m.format("DD/MM/YYYY HH:mm") : fecha;
    },
    getEstadoColorClass(estado) {
      if (!estado) return "status-badge-default";
      const est = estado.toString().toUpperCase();
      if (est.includes("PROCESO")) return "status-badge-process";
      if (est.includes("RECHAZ")) return "status-badge-rejected";
      if (est.includes("APROB")) return "status-badge-approved";
      return "status-badge-default";
    },
    getEstadoIcon(estado) {
      if (!estado) return "mdi-help-circle-outline";
      const est = estado.toString().toUpperCase();
      if (est.includes("PROCESO")) return "mdi-clock-time-four-outline";
      if (est.includes("RECHAZ")) return "mdi-alert-circle-outline";
      if (est.includes("APROB")) return "mdi-check-circle-outline";
      return "mdi-information-outline";
    },
    getEstadoIconColor(estado) {
      if (!estado) return "grey";
      const est = estado.toString().toUpperCase();
      if (est.includes("PROCESO")) return "amber darken-3";
      if (est.includes("RECHAZ")) return "red darken-2";
      if (est.includes("APROB")) return "green darken-2";
      return "grey darken-1";
    },
    navigation() {
      console.log(
        "🚀 ~ file: Bar.vue:75 ~ navigation ~ this.drawer:",
        this.drawer,
      );
      console.log("🚀 ~ file: Bar.vue:77 ~ navigation ~ this.Mini:", this.Mini);
      if (!this.Mini && !this.drawer) {
        this.$emit("drawer", !this.drawer);
      } else {
        this.Minimizar(!this.Mini);
        this.$emit("revertirDespliegue");
      }
    },
    openModalIncidencias() {
      this.verformularioincidencia = true;
      this.dialogformularioincidencia = true;
    },
    abrirUrlSoporte() {
      window.open(this.supportUrl, "_blank");
    },
    cerrarModalIncidencias() {
      this.verformularioincidencia = false;
      this.dialogformularioincidencia = false;
    },
    openModalRespuestaIncidencias() {
      this.verformulariorespuestaincidencia = true;
      this.dialogformulariorespuestaincidencia = true;
    },
    cerrarModalRespuestaIncidencias() {
      this.verformulariorespuestaincidencia = false;
      this.dialogformulariorespuestaincidencia = false;
    },
    openModalModeloMedidas() {
      this.verformularioModeloMedida = true;
      this.dialogformularioModeloMedida = true;
    },
    cerrarModalModeloMedidas() {
      this.verformularioModeloMedida = false;
      this.dialogformularioModeloMedida = false;
    },
    Logout() {
      this.logout();
      localStorage.removeItem("idcliente");
      localStorage.removeItem("role");
      localStorage.removeItem("email");
    },
    Dowloadapp(nombreapk) {
      this.DescargarApk(nombreapk);
    },
    copiarRuc(ruc) {
      if (!ruc) return;
      const texto = String(ruc).trim();
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard
          .writeText(texto)
          .then(() => {
            this.mostrarFeedbackCopia();
          })
          .catch(() => {
            this.copiarFallback(texto);
          });
      } else {
        this.copiarFallback(texto);
      }
    },
    copiarFallback(texto) {
      try {
        const input = document.createElement("input");
        input.setAttribute("value", texto);
        document.body.appendChild(input);
        input.select();
        document.execCommand("copy");
        document.body.removeChild(input);
        this.mostrarFeedbackCopia();
      } catch (e) {
        console.error("Error al copiar RUC:", e);
      }
    },
    mostrarFeedbackCopia() {
      this.rucCopied = true;
      this.snackbarRuc = true;
      if (this.rucCopyTimer) clearTimeout(this.rucCopyTimer);
      this.rucCopyTimer = setTimeout(() => {
        this.rucCopied = false;
      }, 2200);
    },
  },
  beforeDestroy() {
    if (this.rucCopyTimer) {
      clearTimeout(this.rucCopyTimer);
    }
  },
  async mounted() {
    this.roleeee = localStorage.getItem("role");
    let id_cliente =
      sessionStorage.getItem("id_cliente_seleccionado") ||
      sessionStorage.getItem("idcliente") ||
      localStorage.getItem("idcliente");
    this.Getadminreportescount();
    if (id_cliente == undefined || id_cliente == null) {
      this.mostraricononotificaciones = false;
      this.notificaciones = await this.cargarIncidentes();
      this.cantidadincidentes = this.listaIncidentes.length;
      // this.Getadminreportescount();
    } else {
      this.mostraricononotificaciones = true;
      this.Neumaticosareencauchar();
      this.Neumaticosproxareencauchar();
      // this.GetCriterios_();
    }
    this.ObtenerDatosCliente();
    this.ObtenerVersionado();
    if (!this.ClientesUsuario || this.ClientesUsuario.length === 0) {
      try {
        await this.obtenerClientesPorUsuario();
      } catch (e) {}
    }
  },
};
</script>
